import { isUrlValid } from './image-validations';
import { ActionType, GlovoMediaError } from './types';
export function makeMediaInstance() {
    let _initialised = false;
    let _providers = [];
    let _defaultImgUrl = '';
    let _onError;
    const checkInstanceStatus = () => {
        if (!_initialised) {
            throw new GlovoMediaError('Glovo-media instance not initialised');
        }
    };
    return {
        init({ providers, defaultImgUrl, onError }) {
            _providers = providers;
            _initialised = true;
            _defaultImgUrl = defaultImgUrl || '';
            _onError = onError;
        },
        getImageUrl(source, options) {
            const fallbackImage = options?.imageFallbackUrl || _defaultImgUrl;
            checkInstanceStatus();
            if (!source) {
                _onError(new GlovoMediaError('Image source not provided'), {});
                return fallbackImage;
            }
            // we know the provider
            if (options?.providerName) {
                return getImageUrlByProviderName({
                    source,
                    _providers,
                    options,
                    defaultImgUrl: fallbackImage,
                    onError: _onError,
                });
            }
            // if we reach here, then it means we don't know the provider
            return getImageUrlBySource({
                source,
                _providers,
                options,
                defaultImgUrl: fallbackImage,
                onError: _onError,
            });
        },
        async uploadImage(source, options) {
            checkInstanceStatus();
            checkUploadParms(source, options);
            for (const provider of _providers) {
                if (provider.canHandle(ActionType.UploadImage, source) && provider.uploadImage) {
                    return await provider.uploadImage(source, options);
                }
            }
            _onError(new GlovoMediaError('The specified providers cannot handle the upload'), { source });
            throw new GlovoMediaError('The specified providers at the init method cannot handle the upload');
        },
        setDefaultImageUrl(imageUrl) {
            _defaultImgUrl = imageUrl;
        },
    };
}
function checkUploadParms(source, options) {
    if (!source) {
        throw new GlovoMediaError('Image source not provided');
    }
    if (!isUrlValid(options.apiConfig.url)) {
        throw new GlovoMediaError('API URL format is wrong');
    }
    if (!options.apiConfig.authToken) {
        throw new GlovoMediaError('API auth token not provided');
    }
}
function getImageUrlBySource({ source, _providers, options, defaultImgUrl, onError, }) {
    for (const provider of _providers) {
        if (provider.canHandle(ActionType.GetImage, source)) {
            return provider.getImageUrl({ source, transformations: options?.transformations || {} });
        }
    }
    onError(new GlovoMediaError('Provider cannot handle the given source'), {
        source,
        reason: getErrorReason(source),
    });
    return defaultImgUrl;
}
function getErrorReason(source) {
    if (typeof source === 'string') {
        if (source.includes('http://')) {
            return `Lack of SSL`;
        }
        if (!/\.(gif|jpg|jpeg|tiff|png|svg)$/i.test(source)) {
            return `Not an image`;
        }
        if (!source.includes('https://')) {
            return `Lack of HTTP protocol`;
        }
    }
    return `Unknown reason, check the source attribute`;
}
function getImageUrlByProviderName({ source, _providers, options, defaultImgUrl, onError, }) {
    const provider = _providers.find((p) => p.name === options?.providerName);
    if (!provider) {
        onError(new GlovoMediaError('Provider was not found'), {
            providerName: options?.providerName,
        });
        return defaultImgUrl;
    }
    return provider.getImageUrl({ source, transformations: options?.transformations || {} });
}
//# sourceMappingURL=features.js.map